<template>
  <div class="Header" :class="{ isSheetHeader }">
    <div v-if="showSidebarToggle" class="header-sidebar-toggle">
      <HeaderSidebarToggle />
      <div class="header-separator"></div>
    </div>
    <div class="header-slot">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ isSheetHeader?: boolean }>();

const route = useRoute();

const showSidebarToggle = computed(() => !props.isSheetHeader && !route.meta.hideNavbar);
</script>

<style scoped lang="scss">
.Header {
  display: flex;
  align-items: center;
  height: 50px;

  &.isSheetHeader {
    padding-inline: 24px;
    padding-right: 16px;
    border-bottom: 1px solid var(--gray-6);
  }
}

.header-slot {
  gap: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}

.header-separator {
  height: 14px;
  border-left: 1.5px solid var(--gray-5);
  margin-left: 4px;
}

.header-sidebar-toggle {
  display: flex;
  align-items: center;
  padding-right: 4px;
  margin-left: 8px;
}
</style>
